// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

const updateShowNoResultsFound = (state, action) => action.hasNoResult;

export default (state = false, action) => {

    const actionTypes = {
        [actions.UPDATE_SHOW_NO_RESULTS_FOUND]: updateShowNoResultsFound
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/shared/reducers/show-no-results-found.js